import {GlobalContext, ReducerActionType} from "../../GlobalReducer";
import {EcommerceAction} from "../../utils/useDataLayer";
import ModelColorItemInterface from "../../interfaces/model/ModelColorItemInterface";
import {useContext, useEffect} from "react";
import {ReducerStateInterface} from "../../interfaces/core/ReducerStateInterface";
import {getModelItemByParams} from "../../api/catalog";
import {BasketItemInterface} from "../../interfaces/core/BasketItemInterface";
import useDatalayer from "../../utils/useDataLayer";
import {DEFAULT_SHOP_ID} from "../../Config";
import {FavoriteItemInterface} from "../../interfaces/core/FavoriteItemInterface";
import {TriggerEventName} from "../../interfaces/core/TriggerEventInterface";

export default function useModelColorItem(modelColorItem: ModelColorItemInterface) {

    const [state, dispatch] = useContext<[ReducerStateInterface, Function]>(GlobalContext);

    const {action: dataLayerManagerAction} = useDatalayer()

    const toggleFavorite = () => {
        dispatch({
            type: isExistInFavorite() ? ReducerActionType.REMOVE_FROM_FAVORITE : ReducerActionType.ADD_TO_FAVORITE,
            payload: modelColorItem
        })
        dataLayerManagerAction(isExistInFavorite() ? EcommerceAction.REMOVE_FROM_WISHLIST : EcommerceAction.ADD_TO_WISHLIST, [modelColorItem])
        dispatch({
            type: ReducerActionType.ADD_TRIGGER_EVENT,
            payload: {
                event_name: isExistInFavorite() ?  TriggerEventName.WISHLIST_REMOVE : TriggerEventName.WISHLIST_ADD,
                event_value: {
                    model_id: modelColorItem.model_id,
                    color: modelColorItem.color_special,
                    price: modelColorItem.min_price.amount
                },
                customer_identity_type: state.customer?.id ? 'customer_id' : null,
                customer_identity_value: state.customer?.id?.toString() || null,
            },
        });
    }

    const isExistInFavorite = () => {
        const favorites: FavoriteItemInterface[] = state.favorites
        return favorites.filter(modelColorItemIterate => modelColorItemIterate.model_id === modelColorItem.model_id && modelColorItemIterate.color_special?.toLowerCase() === modelColorItem.color_special?.toLowerCase()).length > 0
    }

    const addToBasket = (size: string) => {
        getModelItemByParams(modelColorItem.model_id, modelColorItem.color, size).then((modelItem) => {
            const basketItem: BasketItemInterface = {
                modelColorItem: modelColorItem,
                itemId: modelItem.id,
                color: modelColorItem.color,
                size: size,
                quantity: 1,
                createdAt: new Date()
            }
            dispatch({type: ReducerActionType.ADD_TO_BASKET, payload: basketItem})
            dataLayerManagerAction(EcommerceAction.ADD_TO_CART, [modelColorItem])
            dispatch({
                type: ReducerActionType.ADD_TRIGGER_EVENT,
                payload: {
                    event_name: TriggerEventName.CART_ADD,
                    event_value: {
                        model_id: modelColorItem.model_id,
                        color: modelColorItem.color_special,
                        price: modelColorItem.min_price.amount
                    },
                    customer_identity_type: state.customer?.id ? 'customer_id' : null,
                    customer_identity_value: state.customer?.id?.toString() || null,
                },
            });
        })
    }

    const isExistInBasket = (size: string) => {
        const basket: BasketItemInterface[] = state.basket
        return basket.filter(basketItem => basketItem.modelColorItem?.color_special === modelColorItem.color_special && basketItem.modelColorItem?.model_id === modelColorItem.model_id && basketItem?.size === size).length > 0
    }

    const isSizeAvailable = (size: string, shopId = DEFAULT_SHOP_ID): boolean => {
        if (!modelColorItem.stocks) return true
        return (modelColorItem.stocks[size] && (modelColorItem.stocks[size][DEFAULT_SHOP_ID] || 0) > 0) || false
    }

    const getImages = () => modelColorItem.images.filter(image => !(image.type === 'print'))

    const getVideos = () => modelColorItem.videos.filter(videos => !(videos.type === 'print'))

    const getImageAlt = (): string => {
        return modelColorItem.name + ' Baon ' + modelColorItem.articul
    }

    const isRetailOnly = (size: string): boolean => {
        return modelColorItem.in_retail_only[size] || false
    }


    return {toggleFavorite, addToBasket, isSizeAvailable, isExistInBasket, isExistInFavorite, getImages, getImageAlt, getVideos}
}